/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  ReuseLots,
  ReuseLotsVariables,
  ReuseLots_lotsV2_LotsV2_results_LotV2 as ReuseLot,
} from './types/index.graphql'

export const REUSE_LOTS = gql`
  query ReuseLots($seasonId: Int!, $fieldId: Int!) {
    lotsV2(seasonId: $seasonId, fieldId: $fieldId) {
      results {
        id
        name
        commercialName
        size
        area {
          coordinates
        }
        variety {
          id
          locales {
            es
            en
            pt
          }
        }
        crop {
          id
          locales {
            es
            en
            pt
          }
        }
        rtk {
          coordinates
          type
        }
      }
    }
  }
`
